import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Table, Modal, Form, Stack, Image } from "react-bootstrap";
import Topbar from '../Assets/Topbar';
import LeftSidebar from '../Assets/LeftSidebar';
import { InfinitySpin } from 'react-loader-spinner';
import { postAllShopList, postAdminShopCreate, postShopUpdate, getShopDetailsById, deleteShop, postShopInactivate, getAllState, getAllBarberShop, getProfessionalList, postAssignOwner, postApproveShop, postRejectShop } from '../../../Service';
import { HtmlTagValidation, BlockSQLInjection, checkDuplicateShop, DUPLICATE_SHOP_MESSAGE, DUPLICATE_SHOP_HELPER_MESSAGE, buildShopCreatePayload, buildShopUpdatePayload } from '../../Reusable';
import Select from 'react-select';
import deleteIcon from '../../../images/delete.png';
import editIcon from '../../../images/edit.png';
import approveIcon from '../../../images/check_circle.png';
import rejectIcon from '../../../images/cancel.png';
import reasonInfoIcon from '../../../images/reason-info.png';
import Swal from 'sweetalert2';
import PaginationDesign from '../Assets/Pagination';
// Not loaded globally anywhere (App.js only pulls in App.css/Responsive.css) - without this,
// the .assign-owner-btn/.rejected-btn rules below silently do nothing.
import '../../../css/AdminStyle.css';

// react-select's dropdown popup (menu/options) is styled by its own auto-generated CSS
// classes with hashed names that change between versions - the app's existing dark-theme
// CSS only reaches the input box, not this popup, which is why it renders white. Using the
// "styles" prop instead targets the real parts by name, so it survives library upgrades.
const darkSelectStyles = {
    // Covers the input box itself (typed/focused state was still showing white - the older
    // CSS-based fix for "control" wasn't reaching every state of it, e.g. when focused).
    // transparent (not a solid dark color) to exactly match the other fields around it
    // (.custom-modal .form-control uses "background: transparent" over the modal's own
    // background) - a solid color here looked visibly different from its neighbors.
    control: (base) => ({ ...base, backgroundColor: 'transparent', borderColor: '#565656' }),
    menu: (base) => ({ ...base, backgroundColor: '#1c1c1c', border: '1px solid #565656' }),
    menuList: (base) => ({ ...base, backgroundColor: '#1c1c1c' }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#D49D29' : state.isFocused ? '#333' : '#1c1c1c',
        color: state.isSelected ? '#000' : '#fff',
        cursor: 'pointer'
    }),
    singleValue: (base) => ({ ...base, color: '#fff' }),
    input: (base) => ({ ...base, color: '#fff' }),
    placeholder: (base) => ({ ...base, color: '#9a9a9a' })
};

export default function BusinessList() {

    // postAllShopList now does real server-side search/filter/pagination (searchText,
    // ownedByFilter, statusFilter) - allShops holds just the current page's rows.
    const [allShops, setAllShops] = useState([]);
    const [listCount, setListCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [stateProvinceOption, setStateProvinceOption] = useState([]);

    // ---- Requirement 4: search / "Owned By" filter, Assign / Reassign Owner ----
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
    const [ownedByFilter, setOwnedByFilter] = useState('All');
    // ---- Requirement 6: "Request Status" filter, Approve / Reject ----
    const [statusFilter, setStatusFilter] = useState('All');
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectTargetShop, setRejectTargetShop] = useState(null);
    const [rejectReason, setRejectReason] = useState('');
    const [rejectReasonError, setRejectReasonError] = useState('');
    const [rejectSubmitLoader, setRejectSubmitLoader] = useState(false);
    const [approveLoaderShopId, setApproveLoaderShopId] = useState(null);

    const [showAssignModal, setShowAssignModal] = useState(false);
    const [assignTargetShop, setAssignTargetShop] = useState(null);
    // Also used to resolve the "Requested By" column (a professional id) to a display name.
    const [allProfessionals, setAllProfessionals] = useState([]);
    const [professionalOptions, setProfessionalOptions] = useState([]);
    const [professionalSearchLoader, setProfessionalSearchLoader] = useState(false);
    const [selectedProfessional, setSelectedProfessional] = useState(null);
    const [assignSubmitLoader, setAssignSubmitLoader] = useState(false);

    const OWNED_BY_MAP = { All: 0, Owned: 1, 'Not Owned': 2 };
    const STATUS_MAP = { All: 0, Pending: 1, Approved: 2, Rejected: 3 };

    // Requirement 4/6 filter dropdowns - built with react-select (like State/Select Professional
    // elsewhere in this app) instead of a native <select>, since a native select's popup is
    // drawn by the browser itself and floats over whatever's below it on the page with no way
    // for us to control that - this custom version keeps the popup properly contained instead.
    const OWNED_BY_OPTIONS = [
        { value: 'All', label: 'All' },
        { value: 'Owned', label: 'Owned (owner assigned)' },
        { value: 'Not Owned', label: 'Not Owned (pending)' }
    ];
    const STATUS_OPTIONS = [
        { value: 'All', label: 'All' },
        // label reads "Requested" (not "Pending") to match the status badge shown in the
        // table (getStatusCell renders "Requested" for this same case) - value/STATUS_MAP
        // key stay "Pending" so the statusFilter payload sent to the backend is unchanged.
        { value: 'Pending', label: 'Requested' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Rejected', label: 'Rejected' }
    ];

    const initialFormValues = {
        createdBy: 0,
        name: '',
        address1: '',
        address2: '',
        city: '',
        zipCode: '',
        phoneNumber: '',
        isOwnership: '',
        managerFirstName: '',
        managerLastName: '',
        managerPhoneNumber: '',
        active: true,
        countryId: 1,
        stateProvinceId: ''
    };
    const [formValues, setFormValues] = useState(initialFormValues);
    const [formErrors, setFormErrors] = useState({});

    // Debounce the search box so we don't fire a request on every keystroke.
    useEffect(() => {
        const timer = setTimeout(() => setDebouncedSearchTerm(searchTerm.trim()), 400);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    useEffect(() => {
        getAllState().then(res => {
            if (res.data.statusCode === 200) {
                const options = res.data.stateList.map(s => ({ label: s.stateName, value: s.stateId }));
                setStateProvinceOption(options);
            }
        });
        // Fetched once up front (not just when the Assign modal opens) so the "Requested By"
        // column below can resolve a professional id to a name.
        getProfessionalList().then(res => {
            if (res.data.statusCode === 200) {
                const list = res.data.professionalList || [];
                setAllProfessionals(list.map(p => ({
                    id: p.id,
                    firstName: (p.firstName || '').trim(),
                    lastName: (p.lastName || '').trim()
                })));
            }
        });
    }, []);

    // Reset back to page 1 whenever search/filters change, so a smaller result set never
    // leaves the user stranded on a now-empty page; re-fetch whenever any of these change.
    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchTerm, ownedByFilter, statusFilter]);

    useEffect(() => {
        fetchShopList(currentPage, perPage);
    }, [currentPage, perPage, debouncedSearchTerm, ownedByFilter, statusFilter]);

    const fetchShopList = (page, size) => {
        setLoader(true);
        postAllShopList({
            pageNumber: page,
            pageSize: size,
            searchText: debouncedSearchTerm,
            ownedByFilter: OWNED_BY_MAP[ownedByFilter],
            statusFilter: STATUS_MAP[statusFilter]
        }).then(res => {
            if (res.data.statusCode === 200) {
                setAllShops(res.data.shopList);
                setListCount(res.data.filteredCount);
            }
            setLoader(false);
        }).catch(() => setLoader(false));
    };

    const getBackCurrentPage = (page, size) => {
        setCurrentPage(page);
        setPerPage(size);
    };

    // getStateLabel prefers shop.state (the real field the backend already sends, per the
    // actual API response), falling back to the stateProvinceOption lookup only if it's absent.
    const getStateLabel = (shop) => shop.state || (stateProvinceOption.find(s => s.value === shop.stateProvinceId) || {}).label || '';

    // "Owner" here is the real managerFirstName/managerLastName/managerPhoneNumber captured at
    // creation time (when "Are you the owner?" = Yes), or shop.ownedBy once Assign/Reassign
    // has set a distinct owner (a string professional id, per the live API response).
    const isShopOwned = (shop) => Boolean(shop.managerFirstName || shop.ownedBy);

    // ---- Requirement 6: pending-request helpers ----
    // status: 1 = Pending, 2 = Approved, 3 = Rejected - but status alone isn't reliable,
    // it defaults to 1 even for businesses nobody ever requested. requestedBy is only ever
    // set when a real request exists, so combining both correctly means "there is a genuine,
    // still-unresolved request" - this is what actually decides Approve/Reject vs. Assign
    // Owner/Reassign, per the doc: Assign Owner shows for any unassigned business, Approve/
    // Reject only for one with an actual pending request. Backend added approvedBy/approvedDate,
    // set once a request is approved - but status stays stuck at 1 even then (same unreliability
    // as above), so !shop.approvedBy is needed too or an already-approved request would show
    // Approve/Reject forever.
    const isRequestPending = (shop) => Boolean(shop.requestedBy) && shop.status === 1 && !shop.approvedBy;

    // ---- Dedicated Status column (same idea as Stylist's BusinessList) ----
    // Rejected/Requested reuse the helpers above rather than raw shop.status, since status
    // alone is unreliable (see comment above) - a shop assigned directly via Assign Owner
    // (not through a request) never gets its status touched at all, so isShopOwned (checks
    // managerFirstName/ownedBy directly) is what actually decides "Approved" here, not status.
    // Rejected only: small clickable info icon next to the pill that pops up the reason Admin
    // themselves gave (shop.reject_Reason) - same icon + popup pattern as Stylist's page.
    const showRejectReason = (shop) => {
        Swal.fire({ icon: 'info', title: 'Rejection Reason', text: shop.reject_Reason || 'No reason provided', confirmButtonText: 'Close' });
    };

    // Status column - plain colored text, no background chip: green for Approved, red for
    // Rejected, blue for Requested. Same colors as Stylist's BusinessList so the two pages
    // read consistently.
    const renderStatusLabel = (type, label, shop) => (
        <span className="status-cell-wrap">
            <span className={`status-text status-text-${type}`}>{label}</span>
            {type === 'rejected' && (
                <img
                    src={reasonInfoIcon}
                    alt="View reason"
                    title="View reason"
                    className="reason-info-icon"
                    onClick={() => showRejectReason(shop)}
                />
            )}
        </span>
    );

    const getStatusCell = (shop) => {
        if (shop.status === 3) {
            return renderStatusLabel('rejected', 'Rejected', shop);
        }
        if (isRequestPending(shop)) {
            return renderStatusLabel('requested', 'Requested');
        }
        if (shop.status === 0 && isShopOwned(shop)) {
            // status 0 means "nothing's been approved yet" - a professional who self-owned
            // at creation (isOwnership = Y) or was just handed the shop via Assign Owner and
            // hasn't accepted it yet both land here with an owner already set but status
            // still 0, so show nothing rather than "Approved" (confirmed via shop 229: Y at
            // creation, ownedBy = createdBy, requestedBy/approvedBy null, status 0).
            return '-';
        }
        if (isShopOwned(shop)) {
            return renderStatusLabel('approved', 'Approved');
        }
        return <Button size="sm" variant="outline-secondary" className="status-badge" disabled>Unassigned</Button>;
    };

    const getRequestedByName = (shop) => {
        if (!shop.requestedBy) return '-';
        const p = allProfessionals.find(pr => pr.id === shop.requestedBy);
        return p ? `${p.firstName} ${p.lastName}`.trim() : `#${shop.requestedBy}`;
    };
    // request_Reason is the professional's own reason for requesting - present regardless of
    // status (Pending/Approved/Rejected alike), so Admin can see it before deciding. Shown via
    // the same clickable info-icon + popup pattern as Stylist's reject-reason icon, instead of
    // the raw text inline, so the column stays compact regardless of reason length.
    const showRequestReason = (shop) => {
        Swal.fire({ icon: 'info', title: 'Reason', text: shop.request_Reason || 'No reason provided', confirmButtonText: 'Close' });
    };
    const getReasonCell = (shop) => shop.request_Reason
        ? <img src={reasonInfoIcon} alt="View reason" title="View reason" className="reason-info-icon" onClick={() => showRequestReason(shop)} />
        : '-';

    // ---- Requirement 4: Assign / Reassign Owner ----
    // Real professional-search API: GET /api/Shop/getProfessionalList. It has no search
    // parameter and always returns everyone at once, so the full list is fetched fresh each
    // time the modal opens (handleOpenAssign below), then filtered here client-side as the
    // admin types. Shows the full list immediately (matching how the Business Name dropdown
    // elsewhere in the app behaves) rather than waiting for a minimum number of characters.
    const toProfessionalOption = (p) => ({ label: `${p.firstName} ${p.lastName}`, value: p.id, firstName: p.firstName, lastName: p.lastName });

    const fetchProfessionalOptions = (query) => {
        const term = query.trim().toLowerCase();
        const opts = allProfessionals
            .filter(p => !term || `${p.firstName} ${p.lastName}`.toLowerCase().includes(term))
            .map(toProfessionalOption);
        setProfessionalOptions(opts);
    };

    const handleOpenAssign = (shop) => {
        setAssignTargetShop(shop);
        setSelectedProfessional(isShopOwned(shop)
            // shop.ownedBy comes back as a string ("262") from the API; professionalOptions'
            // values are numbers (from getProfessionalList), so this normalizes to match.
            ? { label: `${shop.managerFirstName || ''} ${shop.managerLastName || ''}`.trim(), value: shop.ownedBy != null ? Number(shop.ownedBy) : undefined }
            : null);
        setProfessionalOptions([]);
        setShowAssignModal(true);
        setProfessionalSearchLoader(true);
        getProfessionalList().then(res => {
            setProfessionalSearchLoader(false);
            if (res.data.statusCode === 200) {
                const list = res.data.professionalList || [];
                const cleaned = list.map(p => ({
                    id: p.id,
                    // Earlier sample data had a lot of stray whitespace padding around names - trimmed here.
                    firstName: (p.firstName || '').trim(),
                    lastName: (p.lastName || '').trim()
                }));
                setAllProfessionals(cleaned);
                setProfessionalOptions(cleaned.map(toProfessionalOption));
            }
        }).catch(() => setProfessionalSearchLoader(false));
    };

    const handleAssignSubmit = () => {
        if (!selectedProfessional || !assignTargetShop) return;
        setAssignSubmitLoader(true);
        postAssignOwner({ shopId: assignTargetShop.id, professionalId: selectedProfessional.value }).then(res => {
            setAssignSubmitLoader(false);
            if (res.data.statusCode === 200) {
                setShowAssignModal(false);
                // Re-fetch so the table reflects the real, saved ownership data from the
                // backend (including notifications-triggering side effects) rather than
                // approximating it locally.
                fetchShopList(currentPage, perPage);
                Swal.fire({ position: 'center', icon: 'success', title: res.data.statusMessage || 'Owner assigned successfully!', showConfirmButton: false, timer: 3000 });
            } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
            }
        }).catch(() => setAssignSubmitLoader(false));
    };

    // ---- Requirement 6: Approve / Reject a pending ownership request ----
    // Per instruction: once a request is Approve'd or Reject'd, BOTH buttons hide (the row
    // is no longer pending) - achieved simply by re-fetching, since the row's status will no
    // longer be 1 (Pending) afterward.
    const handleApprove = (shop) => {
        // Same "Are you sure?" confirm pattern as Delete/Activate-Inactivate above - approving
        // hands over ownership, so it shouldn't fire on a single accidental click.
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to approve this request?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, approve it!'
        }).then((result) => {
            if (!result.isConfirmed) return;
            setApproveLoaderShopId(shop.id);
            postApproveShop({ shopId: shop.id }).then(res => {
                setApproveLoaderShopId(null);
                if (res.data.statusCode === 200) {
                    fetchShopList(currentPage, perPage);
                    Swal.fire({ position: 'center', icon: 'success', title: res.data.statusMessage || 'Shop approved successfully!', showConfirmButton: false, timer: 3000 });
                } else {
                    Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
                }
            }).catch(() => setApproveLoaderShopId(null));
        });
    };

    const handleOpenReject = (shop) => {
        // Same "Are you sure?" confirm pattern as Approve above, asked first here - only once
        // confirmed does the reason-entry modal open, rather than after typing the reason.
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to reject this request?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reject it!'
        }).then((result) => {
            if (!result.isConfirmed) return;
            setRejectTargetShop(shop);
            setRejectReason('');
            setRejectReasonError('');
            setShowRejectModal(true);
        });
    };

    const handleRejectSubmit = () => {
        if (!rejectReason || rejectReason.trim() === '') {
            setRejectReasonError('Reason for rejection is required');
            return;
        }
        setRejectSubmitLoader(true);
        // Backend's Swagger schema shows "reject_Reason" (lowercase r) exactly - not the
        // "rejectRequest_Reason" name from the original API doc, and not "Reject_Reason"
        // (capital R) either, even though that version also happened to pass validation.
        postRejectShop({ shopId: rejectTargetShop.id, reject_Reason: rejectReason.trim() }).then(res => {
            setRejectSubmitLoader(false);
            if (res.data.statusCode === 200) {
                setShowRejectModal(false);
                fetchShopList(currentPage, perPage);
                Swal.fire({ position: 'center', icon: 'success', title: res.data.statusMessage || 'Shop rejected successfully!', showConfirmButton: false, timer: 3000 });
            } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
            }
        }).catch(() => setRejectSubmitLoader(false));
    };

    // ---- Add ----
    const handleAddOpen = () => {
        setFormValues(initialFormValues);
        setFormErrors({});
        setShowAddModal(true);
    };

    const handleAddSubmit = async (e) => {
        e.preventDefault();
        const errors = validate(formValues);
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            const allShopsRes = await getAllBarberShop();
            if (allShopsRes.data.statusCode === 200 && checkDuplicateShop(allShopsRes.data.shopList, formValues)) {
                setFormErrors(prev => ({ ...prev, name: DUPLICATE_SHOP_MESSAGE, stateProvinceId: DUPLICATE_SHOP_HELPER_MESSAGE }));
                return;
            }
            setSubmitLoader(true);
            postAdminShopCreate(buildShopCreatePayload(formValues)).then(res => {
                if (res.data.statusCode === 200) {
                    setShowAddModal(false);
                    setSubmitLoader(false);
                    fetchShopList(currentPage, perPage);
                    Swal.fire({ position: 'center', icon: 'success', title: 'Shop added successfully!', showConfirmButton: false, timer: 3000 });
                } else if (res.data.statusCode === 400) {
                    // Backend's own duplicate-business check (Name + Address1 + State) - same rule as
                    // our client-side pre-check above, kept as a safety net. Uses our own wording
                    // (not res.data.statusMessage) so both layers show identical text to the user.
                    setSubmitLoader(false);
                    setFormErrors(prev => ({ ...prev, name: DUPLICATE_SHOP_MESSAGE, stateProvinceId: DUPLICATE_SHOP_HELPER_MESSAGE }));
                } else {
                    setSubmitLoader(false);
                    Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
                }
            }).catch(() => setSubmitLoader(false));
        }
    };

    // ---- Edit ----
    const handleEditOpen = (shopId) => {
        getShopDetailsById(shopId).then(res => {
            if (res.data.statusCode === 200) {
                const shop = res.data.shopList[0];
                setFormValues({
                    shopId: shop.id,
                    createdBy: shop.createdBy || 0,
                    name: shop.name || '',
                    address1: shop.address1 || '',
                    address2: shop.address2 || '',
                    city: shop.city || '',
                    zipCode: shop.zipPostalCode || '',
                    phoneNumber: shop.phoneNumber || '',
                    isOwnership: shop.isOwnership || '',
                    managerFirstName: shop.managerFirstName || '',
                    managerLastName: shop.managerLastName || '',
                    managerPhoneNumber: shop.managerPhoneNumber || '',
                    active: shop.active,
                    countryId: 1,
                    stateProvinceId: shop.stateProvinceId || ''
                });
                setFormErrors({});
                setShowEditModal(true);
            }
        });
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const errors = validate(formValues);
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            const allShopsRes = await getAllBarberShop();
            if (allShopsRes.data.statusCode === 200 && checkDuplicateShop(allShopsRes.data.shopList, formValues, formValues.shopId)) {
                setFormErrors(prev => ({ ...prev, name: DUPLICATE_SHOP_MESSAGE, stateProvinceId: DUPLICATE_SHOP_HELPER_MESSAGE }));
                return;
            }
            setSubmitLoader(true);
            postShopUpdate(buildShopUpdatePayload(formValues)).then(res => {
                if (res.data.statusCode === 200) {
                    setShowEditModal(false);
                    setSubmitLoader(false);
                    fetchShopList(currentPage, perPage);
                    Swal.fire({ position: 'center', icon: 'success', title: 'Shop updated successfully!', showConfirmButton: false, timer: 3000 });
                } else {
                    setSubmitLoader(false);
                    Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
                }
            }).catch(() => setSubmitLoader(false));
        }
    };

    // ---- Delete ----
    const handleDelete = (shopId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to delete this shop?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteShop(shopId).then(res => {
                    if (res.data.statusCode === 200) {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Shop deleted successfully!',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        fetchShopList(currentPage, perPage);
                    } else {
                        Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
                    }
                });
            }
        });
    };

    // ---- Active / Inactive Toggle ----
    const handleToggleActive = (shop) => {
        const newStatus = !shop.active;
        const actionText = newStatus ? 'Activate' : 'Inactivate';
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to ${actionText} this shop?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: `Yes, ${actionText} it!`
        }).then((result) => {
            if (result.isConfirmed) {
                postShopInactivate({ shopId: shop.id, active: newStatus }).then(res => {
                    if (res.data.statusCode === 200) {
                        setAllShops(prev => prev.map(s =>
                            s.id === shop.id ? { ...s, active: newStatus } : s
                        ));
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: newStatus ? 'Shop activated successfully!' : 'Shop inactivated successfully!',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        Swal.fire({ icon: 'error', title: 'Oops...', text: res.data.statusMessage });
                    }
                }).catch(() => {
                    Swal.fire({ icon: 'error', title: 'Oops...', text: 'Something went wrong. Please try again.' });
                });
            }
        });
    };

    // ---- Phone helpers ----
    const formatPhoneDigits = (digits) => {
        if (!digits || digits.length === 0) return '';
        let fmt = '(' + digits.slice(0, 3);
        if (digits.length > 3) fmt += ') ' + digits.slice(3, 6);
        if (digits.length > 6) fmt += '-' + digits.slice(6, 10);
        return fmt;
    };

    const handlePhoneKeyDown = (e) => {
        BlockSQLInjection(e);
        if (e.key === 'Backspace' && ['phoneNumber', 'managerPhoneNumber'].includes(e.target.name)) {
            e.preventDefault();
            const digits = (formValues[e.target.name] || '').replace(/\D/g, '');
            setFormValues(prev => ({ ...prev, [e.target.name]: formatPhoneDigits(digits.slice(0, -1)) }));
        }
    };

    // ---- Form Change ----
    const handleFormChange = (e) => {
        const { name, value } = e.target;

        if (name === 'isOwnership') {
            // Requirement 3: "No" (or unselected) must not carry any stale owner details
            // forward to Save, even though the fields are hidden once you switch away from "Yes".
            setFormValues(prev => ({
                ...prev,
                isOwnership: value,
                managerFirstName: value === 'Y' ? prev.managerFirstName : '',
                managerLastName: value === 'Y' ? prev.managerLastName : '',
                managerPhoneNumber: value === 'Y' ? prev.managerPhoneNumber : ''
            }));
            return;
        }

        let filteredValue = value;

        if (['managerFirstName', 'managerLastName', 'city'].includes(name)) {
            filteredValue = value.replace(/[^a-zA-Z\s]/g, '');
        } else if (['phoneNumber', 'managerPhoneNumber'].includes(name)) {
            const digits = value.replace(/\D/g, '').slice(0, 10);
            filteredValue = formatPhoneDigits(digits);
        } else if (name === 'zipCode') {
            filteredValue = value.replace(/[^0-9]/g, '').slice(0, 5);
        }

        const capitalizedFields = ['name', 'address1', 'address2', 'city', 'managerFirstName', 'managerLastName'];
        const finalValue = capitalizedFields.includes(name) && filteredValue.length > 0
            ? filteredValue.charAt(0).toUpperCase() + filteredValue.slice(1)
            : filteredValue;
        setFormValues(prev => ({ ...prev, [name]: finalValue }));
    };

    // ---- Validation ----
    const validate = (values) => {
        const errors = {};

        if (!values.name || values.name.trim() === '') {
            errors.name = 'Business name is required';
        } else if (!HtmlTagValidation(values.name)) {
            errors.name = 'Invalid input';
        }

        if (!values.address1 || values.address1.trim() === '') {
            errors.address1 = 'Address 1 is required';
        } else if (!HtmlTagValidation(values.address1)) {
            errors.address1 = 'Invalid input';
        }

        if (!values.city || values.city.trim() === '') {
            errors.city = 'City is required';
        } else if (!/^[a-zA-Z\s]+$/.test(values.city.trim())) {
            errors.city = 'City should contain letters only';
        } else if (!HtmlTagValidation(values.city)) {
            errors.city = 'Invalid input';
        }

        if (!values.stateProvinceId) {
            errors.stateProvinceId = 'Please select a state';
        }

        if (!values.zipCode || values.zipCode.trim() === '') {
            errors.zipCode = 'Zipcode is required';
        } else if (values.zipCode.length !== 5) {
            errors.zipCode = 'Zipcode must be 5 digits';
        }

        if (!values.phoneNumber || values.phoneNumber.trim() === '') {
            errors.phoneNumber = 'Phone number is required';
        } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(values.phoneNumber.trim())) {
            errors.phoneNumber = 'Phone number must be 10 digits';
        }

        if (!values.isOwnership || values.isOwnership === '') {
            errors.isOwnership = 'Please select ownership';
        }

        if (values.isOwnership === 'Y') {
            if (!values.managerFirstName || values.managerFirstName.trim() === '') {
                errors.managerFirstName = 'First name is required';
            } else if (!/^[a-zA-Z\s]+$/.test(values.managerFirstName.trim())) {
                errors.managerFirstName = 'First name should contain letters only';
            } else if (!HtmlTagValidation(values.managerFirstName)) {
                errors.managerFirstName = 'Invalid input';
            }
            if (!values.managerLastName || values.managerLastName.trim() === '') {
                errors.managerLastName = 'Last name is required';
            } else if (!/^[a-zA-Z\s]+$/.test(values.managerLastName.trim())) {
                errors.managerLastName = 'Last name should contain letters only';
            } else if (!HtmlTagValidation(values.managerLastName)) {
                errors.managerLastName = 'Invalid input';
            }
            if (!values.managerPhoneNumber || values.managerPhoneNumber.trim() === '') {
                errors.managerPhoneNumber = 'Phone number is required';
            } else if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(values.managerPhoneNumber.trim())) {
                errors.managerPhoneNumber = 'Phone number must be 10 digits';
            }
        }

        return errors;
    };

    // ---- Shared Modal Form Body ----
    const renderFormFields = () => (
        <>
            <Row className="mb-2">
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Business Name <span className='error'>*</span></Form.Label>
                    <Form.Control
                        onKeyDown={BlockSQLInjection}
                        type="text"
                        name="name"
                        value={formValues.name}
                        onChange={handleFormChange}
                        placeholder="Enter business name"
                    />
                    {formErrors.name && <span className='error'>{formErrors.name}</span>}
                </Form.Group>
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Are you the <span style={{whiteSpace:'nowrap', color:'inherit'}}>owner? <span className='error'>*</span></span></Form.Label>
                    <Form.Select name="isOwnership" value={formValues.isOwnership} onChange={handleFormChange}>
                        <option value="">-- Select --</option>
                        <option value="Y">Yes</option>
                        <option value="N">No</option>
                    </Form.Select>
                    {formErrors.isOwnership && <span className='error'>{formErrors.isOwnership}</span>}
                </Form.Group>
            </Row>

            {formValues.isOwnership === 'Y' && (
                <>
                    <Row className="mb-2">
                        <Form.Group as={Col} className="mb-2">
                            <Form.Label>Owner First Name <span className='error'>*</span></Form.Label>
                            <Form.Control
                                onKeyDown={BlockSQLInjection}
                                type="text"
                                name="managerFirstName"
                                value={formValues.managerFirstName}
                                onChange={handleFormChange}
                                placeholder="Enter first name"
                            />
                            {formErrors.managerFirstName && <span className='error'>{formErrors.managerFirstName}</span>}
                        </Form.Group>
                        <Form.Group as={Col} className="mb-2">
                            <Form.Label>Owner Last Name <span className='error'>*</span></Form.Label>
                            <Form.Control
                                onKeyDown={BlockSQLInjection}
                                type="text"
                                name="managerLastName"
                                value={formValues.managerLastName}
                                onChange={handleFormChange}
                                placeholder="Enter last name"
                            />
                            {formErrors.managerLastName && <span className='error'>{formErrors.managerLastName}</span>}
                        </Form.Group>
                    </Row>
                    <Row className="mb-2">
                        <Form.Group as={Col} className="mb-2">
                            <Form.Label>Owner Phone Number <span className='error'>*</span></Form.Label>
                            <Form.Control
                                onKeyDown={handlePhoneKeyDown}
                                type="text"
                                name="managerPhoneNumber"
                                value={formValues.managerPhoneNumber}
                                onChange={handleFormChange}
                                placeholder="(XXX) XXX-XXXX"
                                maxLength={14}
                            />
                            {formErrors.managerPhoneNumber && <span className='error'>{formErrors.managerPhoneNumber}</span>}
                        </Form.Group>
                        <Col></Col>
                    </Row>
                </>
            )}

            <Row className="mb-2">
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Address 1 <span className='error'>*</span></Form.Label>
                    <Form.Control
                        onKeyDown={BlockSQLInjection}
                        type="text"
                        name="address1"
                        value={formValues.address1}
                        onChange={handleFormChange}
                        placeholder="Enter address 1"
                    />
                    {formErrors.address1 && <span className='error'>{formErrors.address1}</span>}
                </Form.Group>
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control
                        onKeyDown={BlockSQLInjection}
                        type="text"
                        name="address2"
                        value={formValues.address2}
                        onChange={handleFormChange}
                        placeholder="Enter address 2"
                    />
                </Form.Group>
            </Row>

            <Row className="mb-2">
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>City <span className='error'>*</span></Form.Label>
                    <Form.Control
                        onKeyDown={BlockSQLInjection}
                        type="text"
                        name="city"
                        value={formValues.city}
                        onChange={handleFormChange}
                        placeholder="Enter city"
                    />
                    {formErrors.city && <span className='error'>{formErrors.city}</span>}
                </Form.Group>
                <Form.Group as={Col} className="mb-2 select-search-drp adm">
                    <Form.Label>State <span className='error'>*</span></Form.Label>
                    <Select
                        className='selectSearch'
                        styles={darkSelectStyles}
                        options={stateProvinceOption}
                        name='stateProvinceId'
                        onChange={(selected) => setFormValues(prev => ({ ...prev, stateProvinceId: selected ? selected.value : '' }))}
                        value={stateProvinceOption.find(s => s.value === formValues.stateProvinceId) || null}
                        placeholder="Select state"
                    />
                    {formErrors.stateProvinceId && <span className='error'>{formErrors.stateProvinceId}</span>}
                </Form.Group>
            </Row>

            <Row className="mb-2">
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Zipcode <span className='error'>*</span></Form.Label>
                    <Form.Control
                        onKeyDown={BlockSQLInjection}
                        type="text"
                        name="zipCode"
                        value={formValues.zipCode}
                        onChange={handleFormChange}
                        placeholder="Enter zipcode"
                        maxLength={5}
                    />
                    {formErrors.zipCode && <span className='error'>{formErrors.zipCode}</span>}
                </Form.Group>
                <Form.Group as={Col} className="mb-2">
                    <Form.Label>Phone Number <span className='error'>*</span></Form.Label>
                    <Form.Control
                        onKeyDown={handlePhoneKeyDown}
                        type="text"
                        name="phoneNumber"
                        value={formValues.phoneNumber}
                        onChange={handleFormChange}
                        placeholder="(XXX) XXX-XXXX"
                        maxLength={14}
                    />
                    {formErrors.phoneNumber && <span className='error'>{formErrors.phoneNumber}</span>}
                </Form.Group>
            </Row>

        </>
    );

    return (
        <section className='dashboard'>
            <Container>
                <Row className='sideBarRow'>
                    <Col md={3} className='sideBarCol'>
                        <LeftSidebar />
                    </Col>
                    <Col md={9}>
                        <div className='rightsidebar'>

                            <Topbar />

                            <Row className="mb-3 main-title">
                                <Col>
                                    <h1>Business List</h1>
                                </Col>
                            </Row>

                            <Row className="mb-3 managesearch">
                                <Col>
                                    <Stack direction="horizontal" gap={2}>
                                        <div className="add-btn ms-auto">
                                            <Button variant="primary" onClick={handleAddOpen}>Add Shop</Button>
                                        </div>
                                    </Stack>
                                </Col>
                            </Row>

                            <Row className="mb-3 business-filter-bar">
                                <Col>
                                    {/* flexWrap so the two filter dropdowns drop to their own line on
                                        narrower screens instead of getting squeezed and truncated
                                        (this is what was cutting "Pending" down to "Pe"). */}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', rowGap: '10px', marginTop: '10px' }}>
                                        <Form.Control
                                            type="text"
                                            className="business-search-input"
                                            placeholder="Search by business name, address, city, state, owner name, phone..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            style={{ flex: '1 1 300px', minWidth: '200px' }}
                                        />
                                        {/* Groups the two dropdowns together and pushes them to the right of the row
                                            (marginLeft: auto), so the search box stays neatly on the left instead of
                                            sitting right up against them. */}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', rowGap: '10px', marginLeft: 'auto' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: '230px' }}>
                                                <Form.Label className="mb-0" style={{ color: '#fff', whiteSpace: 'nowrap' }}>Owned By:</Form.Label>
                                                <Select
                                                    className='selectSearch'
                                                    options={OWNED_BY_OPTIONS}
                                                    value={OWNED_BY_OPTIONS.find(o => o.value === ownedByFilter)}
                                                    onChange={(selected) => setOwnedByFilter(selected.value)}
                                                    isSearchable={false}
                                                    menuPlacement="auto"
                                                    styles={{ ...darkSelectStyles, container: (base) => ({ ...base, minWidth: '190px', flex: 1 }) }}
                                                />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: '230px' }}>
                                                <Form.Label className="mb-0" style={{ color: '#fff', whiteSpace: 'nowrap' }}>Requested Ownerships:</Form.Label>
                                                <Select
                                                    className='selectSearch'
                                                    options={STATUS_OPTIONS}
                                                    value={STATUS_OPTIONS.find(o => o.value === statusFilter)}
                                                    onChange={(selected) => setStatusFilter(selected.value)}
                                                    isSearchable={false}
                                                    menuPlacement="auto"
                                                    styles={{ ...darkSelectStyles, container: (base) => ({ ...base, minWidth: '150px', flex: 1 }) }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col>
                                    <div className="table-responsive" id="no-more-tables">
                                        <Table striped bordered hover variant="dark" className='emailwrap business-list-table'>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th style={{ minWidth: '180px', whiteSpace: 'nowrap' }}>Business Shop</th>
                                                    <th>Address</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                    <th style={{ minWidth: '110px' }}>Owner First Name</th>
                                                    <th style={{ minWidth: '110px' }}>Owner Last Name</th>
                                                    <th style={{ minWidth: '160px', whiteSpace: 'nowrap' }}>Owner Phone Number</th>
                                                    <th style={{ minWidth: '110px' }}>Requested By</th>
                                                    <th style={{ minWidth: '130px', whiteSpace: 'nowrap' }}>Requested Date</th>
                                                    <th style={{ minWidth: '90px' }}>Requested Reason</th>
                                                    <th style={{ minWidth: '150px' }}>Status</th>
                                                    <th style={{ minWidth: '120px' }}>Active/Inactive</th>
                                                    <th style={{ minWidth: '160px' }}>Action</th>
                                                    <th style={{ minWidth: '140px' }}>Assign Owner</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    loader === true ?
                                                        <tr>
                                                            <td colSpan='15' style={{ textAlign: 'center', paddingLeft: '0px' }}>
                                                                <InfinitySpin height="80" width="200" radius="9" color="#D49D29" ariaLabel="loading" wrapperStyle wrapperClass />
                                                            </td>
                                                        </tr>
                                                    :
                                                        allShops.length > 0 ?
                                                            allShops.map((shop, index) => (
                                                                <tr key={shop.id}>
                                                                    <td className='table-row-number'>{index + 1 + (currentPage * perPage) - perPage}</td>
                                                                    <td data-title="Business Shop">{shop.name}</td>
                                                                    <td data-title="Address">{shop.address1 || '-'}</td>
                                                                    <td data-title="City">{shop.city || '-'}</td>
                                                                    <td data-title="State">{getStateLabel(shop) || '-'}</td>
                                                                    <td data-title="Owner First Name">{shop.managerFirstName || '-'}</td>
                                                                    <td data-title="Owner Last Name">{shop.managerLastName || '-'}</td>
                                                                    <td data-title="Owner Phone Number">{shop.managerPhoneNumber || '-'}</td>
                                                                    <td data-title="Requested By">{getRequestedByName(shop)}</td>
                                                                    <td data-title="Requested Date">{shop.requestedDate || '-'}</td>
                                                                    <td data-title="Reason">{getReasonCell(shop)}</td>
                                                                    <td data-title="Status">{getStatusCell(shop)}</td>
                                                                    <td data-title="Active/Inactive">
                                                                        <Form.Check
                                                                            type="switch"
                                                                            id={`switch-${shop.id}`}
                                                                            checked={shop.active === true}
                                                                            onChange={() => handleToggleActive(shop)}
                                                                            label={shop.active ? 'Active' : 'Inactive'}
                                                                        />
                                                                    </td>
                                                                    {/* Edit/Delete always show now - Approve/Reject join them as icons
                                                                        (same visual style as Edit/Delete) rather than replacing them,
                                                                        and only appear at all while a request is actually pending. */}
                                                                    <td data-title="Action" className='professionalAction'>
                                                                        <Stack direction="horizontal" gap={3} className='professionAction'>
                                                                            <div>
                                                                                <Image src={editIcon} style={{ cursor: 'pointer' }} onClick={() => handleEditOpen(shop.id)} className='tableActionIcon' />
                                                                                <Button className='actionText dltBtn' style={{ cursor: 'pointer' }} onClick={() => handleEditOpen(shop.id)}>Edit</Button>
                                                                            </div>
                                                                            <div>
                                                                                <Image src={deleteIcon} style={{ cursor: 'pointer' }} onClick={() => handleDelete(shop.id)} className='tableActionIcon' />
                                                                                <Button className='actionText dltBtn' style={{ cursor: 'pointer' }} onClick={() => handleDelete(shop.id)}>Delete</Button>
                                                                            </div>
                                                                            {
                                                                                isRequestPending(shop) &&
                                                                                    <>
                                                                                        <div>
                                                                                            <Image
                                                                                                src={approveIcon}
                                                                                                style={{ cursor: approveLoaderShopId === shop.id ? 'default' : 'pointer', opacity: approveLoaderShopId === shop.id ? 0.5 : 1 }}
                                                                                                onClick={() => approveLoaderShopId !== shop.id && handleApprove(shop)}
                                                                                                className='tableActionIcon'
                                                                                            />
                                                                                            <Button className='actionText dltBtn' style={{ cursor: 'pointer' }} onClick={() => handleApprove(shop)} disabled={approveLoaderShopId === shop.id}>
                                                                                                {approveLoaderShopId === shop.id ? '...' : 'Approve'}
                                                                                            </Button>
                                                                                        </div>
                                                                                        <div>
                                                                                            <Image src={rejectIcon} style={{ cursor: 'pointer' }} onClick={() => handleOpenReject(shop)} className='tableActionIcon' />
                                                                                            <Button className='actionText dltBtn' style={{ cursor: 'pointer' }} onClick={() => handleOpenReject(shop)}>Reject</Button>
                                                                                        </div>
                                                                                    </>
                                                                            }
                                                                        </Stack>
                                                                    </td>
                                                                    <td data-title="Assign Owner">
                                                                        {
                                                                            // Own column now, separate from Edit/Delete/Approve/Reject above -
                                                                            // same condition as before (hidden while a request is pending),
                                                                            // just no longer crammed into the same cell.
                                                                            !isRequestPending(shop) ?
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={isShopOwned(shop) ? 'outline-warning' : 'outline-primary'}
                                                                                    className="assign-owner-btn"
                                                                                    onClick={() => handleOpenAssign(shop)}
                                                                                >
                                                                                    {isShopOwned(shop) ? 'Reassign' : 'Assign Owner'}
                                                                                </Button>
                                                                            :
                                                                                '-'
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        :
                                                            <tr>
                                                                <td colSpan='15' style={{ textAlign: 'center' }} className='noDataFound'>No Data Found...</td>
                                                            </tr>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </Col>
                            </Row>

                            {
                                listCount > 0 ?
                                    <PaginationDesign currentPage={currentPage} listCount={listCount} perPage={perPage} getBack={getBackCurrentPage} />
                                :
                                    ''
                            }

                        </div>
                    </Col>
                </Row>
            </Container>

            {/* Add Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)} className="custom-modal" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add Shop</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleAddSubmit}>
                    <Modal.Body>
                        {renderFormFields()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
                        <Button variant="primary" type="submit" disabled={submitLoader}>
                            {submitLoader ? 'Saving...' : 'Save'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} className="custom-modal" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Shop</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleEditSubmit}>
                    <Modal.Body>
                        {renderFormFields()}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
                        <Button variant="primary" type="submit" disabled={submitLoader}>
                            {submitLoader ? 'Updating...' : 'Update'}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Assign / Reassign Owner Modal - Requirement 4 */}
            <Modal show={showAssignModal} onHide={() => setShowAssignModal(false)} className="custom-modal" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{assignTargetShop && isShopOwned(assignTargetShop) ? 'Reassign Owner' : 'Assign Owner'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Business</Form.Label>
                        <Form.Control
                            type="text"
                            readOnly
                            value={assignTargetShop ? [assignTargetShop.name, assignTargetShop.address1, getStateLabel(assignTargetShop)].filter(Boolean).join(', ') : ''}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2 select-search-drp adm">
                        <Form.Label>Select Professional <span className='error'>*</span></Form.Label>
                        <Select
                            className='selectSearch'
                            styles={darkSelectStyles}
                            options={professionalOptions}
                            value={selectedProfessional}
                            onInputChange={(value) => { fetchProfessionalOptions(value); return value; }}
                            onChange={(selected) => setSelectedProfessional(selected)}
                            placeholder="Search professional by name..."
                            isClearable
                            isLoading={professionalSearchLoader}
                            noOptionsMessage={() => 'No matching professional found'}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAssignModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleAssignSubmit} disabled={!selectedProfessional || assignSubmitLoader}>
                        {assignSubmitLoader ? 'Assigning...' : 'Assign'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Reject Ownership Request Modal - Requirement 6 */}
            <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} className="custom-modal" size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Reject Ownership Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Business</Form.Label>
                        <Form.Control
                            type="text"
                            readOnly
                            value={rejectTargetShop ? [rejectTargetShop.name, rejectTargetShop.address1, getStateLabel(rejectTargetShop), `requested by ${getRequestedByName(rejectTargetShop)}`].filter(Boolean).join(', ') : ''}
                        />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Reason for rejection <span className='error'>*</span></Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            onKeyDown={BlockSQLInjection}
                            value={rejectReason}
                            onChange={(e) => {
                                const v = e.target.value;
                                setRejectReason(v.length > 0 ? v.charAt(0).toUpperCase() + v.slice(1) : v);
                                setRejectReasonError('');
                            }}
                            placeholder="Explain why this request is being rejected"
                        />
                        {rejectReasonError && <span className='error'>{rejectReasonError}</span>}
                    </Form.Group>
                    <p style={{ fontSize: '0.85rem', color: '#9a9a9a', marginTop: '10px' }}>
                        Sent to the requesting professional in the rejection email and SMS.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRejectModal(false)}>Cancel</Button>
                    <Button variant="danger" onClick={handleRejectSubmit} disabled={rejectSubmitLoader}>
                        {rejectSubmitLoader ? 'Rejecting...' : 'Reject'}
                    </Button>
                </Modal.Footer>
            </Modal>

        </section>
    );
}